import type { BranchKey } from '@festina-life/api'
import { useTranslate } from '@festina-life/ui/hooks'
import { Modal } from '@festina-life/ui/structure'

import { BranchCreationWizard } from './BranchCreationWizard'
import type { BranchCreationInput } from './types'

type Props = {
  initialValues?: Partial<BranchCreationInput>
  onCreate: (branchKey: BranchKey) => void
  onCancel: () => void
  isOpen: boolean
}

export const BranchCreationWizardModal = ({
  isOpen,
  onCancel,
  onCreate,
  initialValues,
}: Props) => {
  const translate = useTranslate()

  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <Modal.Title title={translate('branchCreationModal.title')} />
      <Modal.Body outerClassName="w-xl">
        <BranchCreationWizard
          onCompleted={onCreate}
          initialValues={initialValues}
        />
      </Modal.Body>
    </Modal>
  )
}
